// src/firebase.js

// 1️⃣ Import Firebase core (ALL imports at top)
import { initializeApp, getApps } from "firebase/app";

// 2️⃣ Import Firebase services
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// 3️⃣ Firebase configuration
const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyDMIrG7vk_3n6Y1yEbf-vSPvfRqbjpME6g",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "virtual-hr-system-5552b.firebaseapp.com",
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID ||
    "virtual-hr-system-5552b",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "virtual-hr-system-5552b.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ||
    "1020310253462",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:1020310253462:web:14a8f4eac37c8b090d77b7",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ||
    "G-NQ5QHFJ070",
};

// 4️⃣ Initialize Firebase safely (no duplicate app error)
const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// 5️⃣ Initialize services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// 6️⃣ Admin email (role-based access)
const ADMIN_EMAIL =
  process.env.REACT_APP_ADMIN_EMAIL || "admin@yourdomain.com";

// 7️⃣ Export everything
export { db, auth, storage, ADMIN_EMAIL };
export default app;